import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateMaintenanceSchedule($companyId: ID!, $id: ID!, $attributes: MaintenanceScheduleAttributes!) {
    updateMaintenanceSchedule(companyId: $companyId, id: $id, attributes: $attributes) {
      maintenanceSchedule {
        id
        ...UpdatedMaintenanceSchedule
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedMaintenanceSchedule on MaintenanceSchedule {
    id
    maintenanceType {
      id
    }
    details
    repeatMultiplier
    repeatPeriod
  }
`
